import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad betyder personlig lämplighet enligt alkohollagen?";
const SHORT_ANSWER = "Att du har visat skötsamhet i ekonomi och vandel, saknar relevant brottslighet och har de kunskaper som krävs för att bedriva alkoholservering enligt lagen.";

export const Route = createFileRoute("/fraga/vad-betyder-personlig-lamplighet")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad betyder personlig lämplighet enligt alkohol…" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Kommunen begär utdrag från Skatteverket, polisen och Bolagsverket. Tidigare ekobrott, skatteskulder eller upprepade trafikbrott kan diskvalificera. Personlig lämplighet prövas på alla i PBI-kretsen."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "PBI-kretsen och lämplighetsprövning" }}
      related={[{"to": "/fraga/vad-ar-pbi-kretsen", "label": "Vad är PBI-kretsen?"}, {"to": "/fraga/kan-mitt-tillstand-aterkallas", "label": "Kan mitt serveringstillstånd återkallas?"}, {"to": "/fraga/far-jag-saljs-pa-bordet", "label": "Får gäster själva fylla på drinkar vid bordet?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad betyder personlig lämplighet enligt alkohollagen?" },
      { name: "description", content: "Att du har visat skötsamhet i ekonomi och vandel, saknar relevant brottslighet och har de kunskaper som krävs för att bedriva alkoholservering enligt lagen." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-betyder-personlig-lamplighet" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-betyder-personlig-lamplighet" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-betyder-personlig-lamplighet",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad betyder personlig lämplighet enligt alkohol…", url: "https://alkoholprovet.se/fraga/vad-betyder-personlig-lamplighet" },
      ]),
    ],
  }),
});
